import { selectCountries } from "../../../../../components/appData.slice";
import { FormElement, FormId } from "../../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../../components/types";
import { Url } from "../../../../../router/enums";
import { provinces } from "../../../../../shared";
import {
  selectIsDefaultCountrySelected,
  selectIsNotDefaultCountrySelected,
} from "../../../../../store/HOC/genericUI.selectors";
import { postalCodeMask } from "../../../../../utilities/masks";
import {
  selectCircumAvailableCities,
  selectIncidentCircumstancesData,
  selectUIData,
} from "../incident.selectors";
import { setAvailableCities, setUIField } from "../incident.slice";

import { ComponentId } from "./enums";

export const form: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.INCIDENT_CIRCUMSTANCES,
  selector: selectIncidentCircumstancesData,
  redirect: Url.OC_PROPERTY_OWNER,
  content: [
    {
      title: "Okoliczności",
      sections: [
        {
          id: "incident-circumstances-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.DATE_PICKER,
              id: ComponentId.DATE,
              required: true,
              isSubmitted: false,
              label: "Data zdarzenia",
            },
            {
              type: FormElement.TIME_PICKER,
              id: ComponentId.HOUR,
              required: true,
              label: "Godzina zdarzenia",
            },
          ],
        },
        {
          id: "incident-circumstances-data-2",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.TEXTAREA,
              id: ComponentId.PLACE,
              required: true,
              label: "Ulica / Droga / Skrzyżowanie",
              limit: 250,
              placeholder: "Proszę wpisać dokładne miejsce zdarzenia",
            },
          ],
        },
        {
          id: "incident-circumstances-data-3",
          wrapper: { xs: 12 },
          components: [
            {
              isVisible: selectIsNotDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              type: FormElement.ZIP_CODE,
              mask: postalCodeMask,
              id: ComponentId.ZIP_CODE_PL,
              label: "Kod pocztowy",
              // LPPLWEBMOB-728
              onChange: setAvailableCities,
            },
            {
              isVisible: selectIsDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              type: FormElement.INPUT,
              id: ComponentId.ZIP_CODE_GENERIC,
              label: "Kod pocztowy",
            },
            // LPPLWEBMOB-728
            {
              isVisible: selectIsNotDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              type: FormElement.SELECT_CITY,
              id: ComponentId.CITY,
              label: "Miejscowość",
              items: [],
              selectAvailableCities: selectCircumAvailableCities,
            },
            {
              isVisible: selectIsDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              type: FormElement.INPUT,
              id: ComponentId.CITY,
              label: "Miejscowość",
            },
          ],
        },
        {
          id: "incident-circumstances-data-4",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.AUTOCOMPLETE,
              id: ComponentId.COUNTRY,
              onChange: setUIField,
              items: selectCountries,
              label: "Kraj",
            },
            {
              type: FormElement.SELECT,
              id: ComponentId.PROVINCE,
              disabled: selectIsDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              label: "Województwo",
              items: [...provinces],
            },
          ],
        },
        {
          id: "incident-circumstances-data-5",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.TEXTAREA,
              id: ComponentId.DESCRIPTION,
              label:
                "Jak doszło do zdarzenia? Jak się Pan/Pani o nim dowiedział/a?",
              limit: 2000,
            },
          ],
        },
      ],
    },
  ],
};
